import React from 'react';
import {Flex} from '@components';
import {Form, Input, Button, Upload, Icon} from 'antd';
import SiderMenu from '@pages/Assembly/siderMenu';
import Breadcrumb from '@pages/Assembly/Breadcrumb';
import TitleTop from '@pages/Assembly/titleTop';
import NHFetch from "@utils/NHFetch";
import {message} from "antd/lib/index";
import {getLoginUser} from '@utils/NHCore';
import NextButton from '@pages/SelfHelp/common/nextIndex'
import createHistory from 'history/createHashHistory';
import CommonTip from "../common";
import {mkbz} from "@pages/Assembly/siderMenu/menuObj";
import Hint from "@pages/SelfHelp/common/hint";


const history = createHistory();


const basicUrl = "api/zhxg-yxxt/yxwz";
const FormItem = Form.Item;

const formItemLayout = {
    labelCol: {span: 8},
    wrapperCol: {span: 16}
};

const uploadUrl = "api/zhxg-yxwz/newStudent/cacheStudentPhoto"; //上传logo路径
function beforeUpload(file) {

    const isJPG = file.type === "image/jpeg" || file.type === "image/png";
    if (!isJPG) {
        message.error("You can only upload JPG file!");
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
        message.error("Image must smaller than 2MB!");
    }
    return isJPG && isLt2M;
}

@Form.create()
export default class antiepidemic extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            mkbz: 'GD035_1',
            hjmc: '',
            editable: true,
            update: false,
            initPOvalue: {
                xsid: '',
                shzt: '',
            },
            value: null,
            lxjtgjmcList: {},
            lxjtgjmc: '',
            ddz: {},
            options: [],
            dqddz: '',
            nextUrl: '',//左侧菜单加载完后传进来
            search: '',
            operable: true,//是否显示环节
            nonOperationalData: {},//不可操作的数据
            isHide: true,
            day: '48小时',//   xx天，默认48小时
            LcidData: {},//lchjid
        };
    }


    componentWillMount() {
    }

    //渲染前获取信息
    componentDidMount() {
        this.queryQztjAndYlhj();
        this.getFydjInfo();
    }



    //查询前置条件和依赖环节
    queryQztjAndYlhj = () => {
        let xsid = getLoginUser() ? getLoginUser().userId : '';
        if (!xsid) {
            this.setState({
                nonOperationalData: {nologin: true},
                operable: false,
            });
            return;
        }
        let zzbdhjid = this.getQueryString('pkid');
        NHFetch("/zzbd/queryQztjAndYlhj", 'GET', {xsid: xsid, zzbdhjid: zzbdhjid})
            .then(res => {
                if (res && res.data) {
                    let kfsj = res.data['kfsj'];
                    let ylhj = res.data['ylhj'];
                    let qzhj = res.data['qzhj'];
                    let nohj = res.data['nohj'];
                    this.setState({nonOperationalData: res.data});
                    if (kfsj && kfsj['YXSJ'] != '1') {
                        this.setState({operable: false});
                    }

                    if (ylhj && ylhj.length > 0) {
                        this.setState({operable: false});
                    }

                    if (qzhj && qzhj.length > 0) {
                        this.setState({operable: false});
                    }
                    if (nohj) {
                        this.setState({operable: false});
                    }
                }
            });
    }

    getQueryString = (name) => {
        return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
    }

    setMenuList = (menuList) => {
        let nextCount = 0;
        let bz = this.state.mkbz;
        menuList.map((elem, index) => {
            if (elem.HJDM == bz) {
                let hjmc = elem.HJMC;
                this.setState({hjmc: hjmc})
                nextCount = index + 1;
                return;
            }
        });
        let menu = menuList[nextCount];
        if (menu) {
            let hjdm = menu.HJDM;
            if (hjdm.indexOf('GD') == 0) {
                let gdUrl = mkbz[hjdm];
                this.setState({
                    nextUrl: gdUrl,
                    search: 'pkid=' + menu.PKID,
                })
            } else if (hjdm.indexOf('ZDY') == 0) {
                let zdyUrl = "/customLink";
                this.setState({
                    nextUrl: zdyUrl,
                    search: 'pkid=' + menu.PKID + '&mkbz=' + hjdm + '&lx=' + menu.LX,
                })
            } else if(hjdm.indexOf('DCWJ')==0){
                let wjUrl  = "/customizeExamination";
                this.setState({
                    nextUrl:wjUrl,
                    search:'pkid='+menu.PKID+'&mkbz='+hjdm,
                })
            }
        } else {
            this.setState({
                nextUrl: '',
                search: '',
            })
        }
    }


    handleSubmit = e => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!this.state.editable) {
                this.setState({editable: true});
                return
            }
            if (err) {
                return;
            }

            const xsid = getLoginUser().userId;
            const zzbdhjid = this.getUrlParams("pkid");
            values['xsid'] = xsid
            values['zzbdhjid'] = zzbdhjid
            let params = values
            //请求保存或修改数据 
            NHFetch('/zzbd/dlxxbd/insertOrUpdate', 'POST', params)
                .then(res => {
                    if (res) {
                        if (res.data == '1') {
                            // this.commonSaveLinkTransactionStatus();
                            message.success('信息保存成功！');
                            this.reloadMenu();
                            this.getFydjInfo();
                        } else {
                            message.error('信息保存失败，请重试！');
                        }
                    }
                })
        });
    };


    //获取url中传递的参数
    getUrlParams = (param) => {
        return decodeURIComponent((new RegExp('[?|&]' + param + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ''])[1].replace(/\+/g, '%20')) || null
    };


    //重新加载菜单
    reloadMenu = () => {
        this.refs.siderMenu.reloadMenuList()
    }


    getFydjInfo = () => {
        const xsid = getLoginUser().userId;
        NHFetch("/zzbd/dlxxbd/getFydjInfoByXsid", "GET", {xsid: xsid})
            .then(res => {
                if (res) {
                    if (res.data) {
                        this.setState({
                            initPOvalue: res.data,
                            editable: false,
                            imageTzstpUrl: `data:image/jpeg;base64,${res.data.tzstp}`,
                            imageSfzzmtpUrl: `data:image/jpeg;base64,${res.data.sfzzmtp}`,
                            imageSfzfmtpUrl: `data:image/jpeg;base64,${res.data.sfzfmtp}`,
                            imageJqzUrl: `data:image/jpeg;base64,${res.data.jqzp}`
                        });
                    }
                }
            });
    }


    getBase64(img, callback) {
        const reader = new FileReader();
        reader.addEventListener('load', () => callback(reader.result));
        reader.readAsDataURL(img);
    }

    // 上传图片
    handleUploadChange = (info, type) => {
        let userId = getLoginUser() ? getLoginUser().userId : undefined;
        if (info && info['file'] && info['file'].status === 'done') {
            let photoUUID = info['file'].response.data;
            if (photoUUID) {
                let url = '/zzbd/dlxxbd/saveFydjTp?xsid=' + userId + '&photoUUID=' + photoUUID + '&type=' + type;
                NHFetch(url, 'POST')
                    .then(res => {
                        if (res && res.data) {
                            message.success("上传成功!")
                        }
                    });
            }
        }
        if ("tzs" === type) {
            this.getBase64(info.file.originFileObj, imageTzstpUrl =>
                this.setState({imageTzstpUrl})
            );
        }
        if ("sfzzm" === type) {
            this.getBase64(info.file.originFileObj, imageSfzzmtpUrl =>
                this.setState({imageSfzzmtpUrl})
            );
        }
        if ("sfzfm" === type) {
            this.getBase64(info.file.originFileObj, imageSfzfmtpUrl =>
                this.setState({imageSfzfmtpUrl})
            )
        }
        if ("jqz" === type) {
            this.getBase64(info.file.originFileObj, imageJqzUrl =>
                this.setState({imageJqzUrl})
            )
        }
    }

    render() {
        const uploadButton = (
            <div>
                <Icon type={'plus'}/>
                <div style={{marginTop: 8, color: '#666'}}>Upload</div>
            </div>
        );
        const {getFieldDecorator} = this.props.form;
        const {
            editable,
            xsid,
            imageTzstpUrl,
            imageSfzzmtpUrl,
            imageSfzfmtpUrl,
            imageJqzUrl
        } = this.state;
        // let str = '近' + day + '的核酸检测结果：'
        return (
            <div>{this.state.operable ?
                <Flex className="w1180 mt-20" align="start">
                    <SiderMenu
                        ref={"siderMenu"}
                        setMenuList={this.setMenuList}
                        title="自助报到"
                        /* active={3}*/
                        mkbz={this.state.mkbz}
                        menuType='自助报到'
                    />
                    <Flex.Item className="page_con_r" styleName="">
                        <Breadcrumb
                            noLine
                            list={[
                                {name: '首页', url: '/index'},
                                {name: '自助报到', url: '/register'},
                                {name: this.state.hjmc}
                            ]}
                        />
                        <div className="box">
                            <Hint/>
                            <TitleTop title={this.state.hjmc} extra={false}/>
                            <Form onSubmit={this.handleSubmit}>
                                <div className="p-sw">
                                    <Flex align="start" wrap="wrap">

                                        <div className="form_item">
                                            <FormItem
                                                {...{
                                                    labelCol: {span: 6},
                                                    wrapperCol: {span: 18}
                                                }}
                                                labelAlign={'left'}
                                                label={"通知书照片"}
                                            >
                                                <Upload
                                                    name="photo"
                                                    accept={'image/*'}
                                                    showUploadList={false}
                                                    disabled={!editable}
                                                    listType="picture-card"
                                                    style={{width: 128, height: 128}}
                                                    action={uploadUrl + "?xsid=" + xsid}
                                                    beforeUpload={beforeUpload}
                                                    onChange={(info) => this.handleUploadChange(info, "tzs")}
                                                >
                                                    {imageTzstpUrl ? <img src={imageTzstpUrl} alt="avatar"
                                                                         style={{width: '100%'}}/> : uploadButton}
                                                </Upload>
                                                {/* )} */}
                                            </FormItem>
                                            <FormItem
                                                {...{
                                                    labelCol: {span: 6},
                                                    wrapperCol: {span: 18}
                                                }}
                                                labelAlign={'left'}
                                                label="身份证正面照片"
                                            >
                                                {/* {getFieldDecorator('jkmjt', {
                                                // initialValue: initPOvalue.cfddqdmArray ? initPOvalue.cfddqdmArray : [],
                                            })( */}
                                                <Upload
                                                    name="photo"
                                                    accept={'image/*'}
                                                    showUploadList={false}
                                                    disabled={!editable}
                                                    listType="picture-card"
                                                    style={{width: 128, height: 128}}
                                                    action={uploadUrl + "?xsid=" + xsid}
                                                    beforeUpload={beforeUpload}
                                                    onChange={(info) => this.handleUploadChange(info, "sfzzm")}
                                                >
                                                    {imageSfzzmtpUrl ? <img src={imageSfzzmtpUrl} alt="avatar"
                                                                          style={{width: '100%'}}/> : uploadButton}
                                                </Upload>
                                                {/* )} */}
                                            </FormItem>
                                            <FormItem
                                                {...{
                                                    labelCol: {span: 6},
                                                    wrapperCol: {span: 18}
                                                }}
                                                labelAlign={'left'}
                                                label="身份证反面照片"
                                            >
                                                {/* {getFieldDecorator('xcmjt', {
                                                // initialValue: initPOvalue.cfddqdmArray ? initPOvalue.cfddqdmArray : [],
                                            })( */}
                                                <Upload
                                                    name="photo"
                                                    accept={'image/*'}
                                                    listType="picture-card"
                                                    style={{width: 128, height: 128}}
                                                    showUploadList={false}
                                                    disabled={!editable}
                                                    action={uploadUrl + "?xsid=" + xsid}
                                                    beforeUpload={beforeUpload}
                                                    onChange={(info) => this.handleUploadChange(info, "sfzfm")}
                                                >
                                                    {imageSfzfmtpUrl ? <img src={imageSfzfmtpUrl} alt="avatar"
                                                                          style={{width: '100%'}}/> : uploadButton}
                                                </Upload>
                                                {/* )} */}
                                            </FormItem>
                                            <FormItem
                                                {...{
                                                    labelCol: {span: 6},
                                                    wrapperCol: {span: 18}
                                                }}
                                                labelAlign={'left'}
                                                label="本人近期照片"
                                            >
                                                {/* {getFieldDecorator('xcmjt', {
                                                // initialValue: initPOvalue.cfddqdmArray ? initPOvalue.cfddqdmArray : [],
                                            })( */}
                                                <Upload
                                                    name="photo"
                                                    accept={'image/*'}
                                                    listType="picture-card"
                                                    style={{width: 128, height: 128}}
                                                    showUploadList={false}
                                                    disabled={!editable}
                                                    action={uploadUrl + "?xsid=" + xsid}
                                                    beforeUpload={beforeUpload}
                                                    onChange={(info) => this.handleUploadChange(info, "jqz")}
                                                >
                                                    {imageJqzUrl ? <img src={imageJqzUrl} alt="avatar"
                                                                          style={{width: '100%'}}/> : uploadButton}
                                                </Upload>
                                                {/* )} */}
                                            </FormItem>
                                        </div>
                                    </Flex>
                                    <div className="text-center mt-50">
                                        {
                                            <Button
                                                type="primary"
                                                htmlType="submit"
                                                disabled={!editable && this.state.initPOvalue.shzt!=='3'}
                                            >
                                                {editable ? '保存' : '修改'}
                                            </Button>
                                        }
                                        <NextButton nextUrl={this.state.nextUrl} search={this.state.search}/>
                                    </div>
                                </div>
                            </Form>
                        </div>
                    </Flex.Item>
                </Flex>
                :
                <CommonTip hjmc={"信息比对"} key={'GD035_1'} mkbz='GD035_1'
                           nonOperationalData={this.state.nonOperationalData}/>
            }
            </div>
        );
    }
}
